<div class="container">
    <div class="list-selector">
        <app-folders-list-boxes-selector-container></app-folders-list-boxes-selector-container>
    </div>
    <div class="list-container">
        <div class="list-header">
            <app-view-selector [defaultSelectedView]="defaultView" (viewSelected)="onViewSelected($event)"></app-view-selector>
            <app-folders-list-header [view]="view" [configuration]="configuration"></app-folders-list-header>
        </div>
        <div class="list-data">
            <app-folders-list-datas [view]="view" [configuration]="configuration" (folderDisplayed)="onFolderDisplayed($event)"></app-folders-list-datas>
            <ngx-spinner name="folders-spinner" [fullScreen]="false" type="timer" size="medium"></ngx-spinner>
        </div>
    </div>
    <ngx-spinner name="folders-container-spinner" [fullScreen]="false" type="timer" size="medium"></ngx-spinner>
</div>
